import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

import Cover from './Cover';
import { CHILDREN_PROPTYPES } from 'base/constants/propTypes';

const styles = theme => ({
  root: {
    backgroundColor: ({ background }) =>
      background || theme.palette.background.secondary,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%'
  }
});

const DarkCover = ({ children, classes, dataTestId }) => {
  return (
    <Cover classes={classes} dataTestId={dataTestId}>
      {children}
    </Cover>
  );
};

DarkCover.propTypes = {
  children: CHILDREN_PROPTYPES,
  classes: PropTypes.shape({}),
  dataTestId: PropTypes.string
};

export default withStyles(styles)(DarkCover);
